import { getRgObjectsOfType as s, RG_TYPE as o } from "@project-rouge/rg-core";
import { getLevelCount as u } from "../../object-helpers/index3.js";
const d = (i) => {
  let t = 0;
  const c = s(i, o.Building);
  for (const l of c) {
    const e = [], r = u(l, !1);
    for (const n of l.children)
      if (n.type === o.Apartment && !e.includes(n.data.level) && (e.push(n.data.level), e.length === r))
        break;
    t = Math.max(t, e.length);
  }
  return t;
};
export {
  d as getResidentialLevelCount
};
//# sourceMappingURL=index49.js.map
